import { gql } from 'graphql-request';
import {
  ProjectID,
  ProjectName,
  ProjectNanoID,
  ProjectStatus,
  ProjectUUID
} from '../../projects/projectsTypes';
import {
  TaskID,
  TaskName,
  TaskNanoID,
  TaskStatus,
  TaskUUID
} from '../../tasks/tasksTypes';

export type CacheFetchShowProjectsTaskChildProjectsTask =
  | CacheFetchShowProjectsTaskChildTask
  | CacheFetchShowProjectsTaskChildProject;

export type CacheFetchShowProjectsTaskChildProjectsTasks =
  CacheFetchShowProjectsTaskChildProjectsTask[];

export type CacheFetchShowProjectsTaskChildTask = {
  name: TaskName;
  nanoId: TaskNanoID;
  originalId: TaskID;
  status: TaskStatus;
  type: 'task';
  uuid: TaskUUID;
};

export type CacheFetchShowProjectsTaskChildProject = {
  childProjectsTasks?: CacheFetchShowProjectsTaskChildProjectsTasks;
  name: ProjectName;
  nanoId: ProjectNanoID;
  originalId: ProjectID;
  status: ProjectStatus;
  type: 'project';
  uuid: ProjectUUID;
};

export interface CacheFetchShowProjectsTaskChildProjectsTasksQueryResponse {
  childProjectsTasks?: CacheFetchShowProjectsTaskChildProjectsTasks;
  name: ProjectName;
  nanoId: ProjectNanoID;
  originalId: ProjectID;
  status: ProjectStatus;
  type: 'project';
  uuid: ProjectUUID;
}

export const CACHE_FETCH_SHOW_PROJECTS_TASK_CHILD_PROJECTS_TASKS_QUERY = gql`
  query CacheShowProjectsTaskChildProjectsTasks($uuid: ID!, $source: String) {
    projectsTask(uuid: $uuid, source: $source) {
      uuid
      nanoId
      name
      status
      type
      originalId
      childProjectsTasks {
        uuid
        nanoId
        name
        status
        type
        originalId
        childProjectsTasks {
          uuid
          nanoId
          name
          status
          type
          originalId
          childProjectsTasks {
            uuid
            nanoId
            name
            status
            type
            originalId
            childProjectsTasks {
              uuid
              nanoId
              name
              status
              type
              originalId
              childProjectsTasks {
                uuid
                nanoId
                name
                status
                type
                originalId
                childProjectsTasks {
                  uuid
                  nanoId
                  name
                  status
                  type
                  originalId
                }
              }
            }
          }
        }
      }
    }
  }
`;
